import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FieldWrapper = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));
